module.exports = __webpack_public_path__ + "img/r5.4681b92a.png";